// Demo presets for Kindergarten Communication of Learning: Final Observations.

export const PRESETS = [
  {
    label: 'Example: Avery Park (Year 1)',
    data: {
      date: '2025-06-15',
      studentName: 'Avery Park',
      oen: '123456789',
      year: 'Year 1',
      daysAbsent: '3',
      totalDaysAbsent: '5',
      timesLate: '0',
      totalTimesLate: '1',
      frenchProgram: '',
      teacher: 'Ms. Patricia Rodriguez',
      earlyChildhoodEducator: 'Ms. Linda Chen',
      principal: 'Mr. David Thompson',
      telephone: '(416) 555-0123',
      board: 'Toronto District School Board',
      school: 'Sunrise Public School',
      schoolAddress: '123 Maple Street\nToronto, ON M5V 2T6',
      boardAddress: '5050 Yonge Street\nToronto, ON M2N 5N8',
      placement: 'Kindergarten Year 2',
      belongingEsl: '',
      belongingIep: '',
      belongingComments:
        'Avery has formed warm friendships across the classroom this year and consistently looks out for peers during group play. ' +
        'During circle time, Avery shares thoughts about family traditions, contributing to our growing class community. ' +
        'Avery has grown in willingness to invite quieter classmates into shared activities and offers reassurance during transitions. ' +
        'Next steps include taking on shared leadership roles during classroom routines and exploring how to express ideas about belonging through art and storytelling.',
      selfRegulationEsl: '',
      selfRegulationIep: '',
      selfRegulationComments:
        'Avery is developing strong self-awareness, naming feelings of excitement and frustration during transitions. ' +
        'Calm-down strategies introduced this term (taking three breaths, choosing a quiet corner) are being used independently with growing success. ' +
        'Avery is beginning to anticipate transitions and prepare for them by tidying materials before being prompted. ' +
        'Next steps include extending these strategies to less familiar situations and continuing to support physical wellness through outdoor active play.',
      literacyMathEsl: '',
      literacyMathIep: '',
      literacyMathComments:
        'Avery recognizes most uppercase letters and writes his own name independently. ' +
        'During shared reading, Avery points to familiar words and predicts what might come next, demonstrating early reading behaviours. ' +
        'In mathematics, Avery counts collections reliably to fifteen and is beginning to compare quantities using more/less language. ' +
        'Next steps include extending writing to short messages for peers and exploring number patterns through everyday play.',
      problemSolvingEsl: '',
      problemSolvingIep: '',
      problemSolvingComments:
        'Avery approaches challenges in the block centre with creativity, testing different stacking strategies until structures stand stably. ' +
        'When materials run short, Avery offers solutions and negotiates with peers to share. ' +
        'Avery has grown in willingness to ask thoughtful questions about how things work, particularly in the science exploration area. ' +
        'Next steps include continuing to document discoveries through drawings and photos and sharing findings with small groups.',
      ersCompleted: '',
      ersDateYear: '',
      ersDateMonth: '',
      ersDateDay: '',
      ersBenchmarkMet: '',
      eceNames: 'Ms. Linda Chen',
      _completedFields: [],
    },
  },
  {
    label: 'Example: Jaylen Lee (Year 2)',
    data: {
      date: '2025-06-18',
      studentName: 'Jaylen Lee',
      oen: '987654321',
      year: 'Year 2',
      daysAbsent: '1',
      totalDaysAbsent: '4',
      timesLate: '0',
      totalTimesLate: '0',
      frenchProgram: 'Core',
      teacher: 'Mr. Samuel Patel',
      earlyChildhoodEducator: 'Ms. Aisha Nguyen',
      principal: 'Ms. Elena Rossi',
      telephone: '(905) 555-0456',
      board: 'Peel District School Board',
      school: 'Maplewood Elementary',
      schoolAddress: '88 Cedar Ave\nMississauga, ON L5B 1Y3',
      boardAddress: '5650 Hurontario Street\nMississauga, ON L5R 1C6',
      placement: 'Grade 1',
      belongingEsl: '',
      belongingIep: 'true',
      belongingComments:
        'Jaylen has built strong, trusting relationships with peers and adults across the kindergarten community. ' +
        'During collaborative play, Jaylen takes the initiative to include classmates and explain group rules with care. ' +
        'Jaylen has grown in confidence to share family and cultural traditions during community circle. ' +
        'Per the IEP, next steps include continuing to use visual supports while taking on classroom-wide roles such as line leader or recycling helper.',
      selfRegulationEsl: '',
      selfRegulationIep: 'true',
      selfRegulationComments:
        'Jaylen recognizes emotional cues in peers and is beginning to offer comfort when classmates feel upset. ' +
        'Self-regulation strategies (deep breathing, counting forward) are now used independently across the day. ' +
        'Jaylen advocates for personal needs (water, quiet time) using full sentences. ' +
        'Next steps include extending these tools to less structured outdoor settings and continuing to support stamina across longer periods of focused work.',
      literacyMathEsl: '',
      literacyMathIep: 'true',
      literacyMathComments:
        'Jaylen reads simple high-frequency words and writes short sentences with growing confidence. ' +
        'In mathematics, Jaylen demonstrates understanding of one-to-one correspondence to twenty and identifies simple patterns. ' +
        'Jaylen draws to communicate stories and labels work with familiar words. ' +
        'Per the IEP, next steps include using sentence starters to extend written stories and exploring simple addition through hands-on materials.',
      problemSolvingEsl: '',
      problemSolvingIep: '',
      problemSolvingComments:
        'Jaylen experiments enthusiastically at the inquiry table, asking "what would happen if…" questions and recording observations. ' +
        'When a plan does not work, Jaylen revises calmly and shares the new approach with peers. ' +
        'Jaylen has grown in confidence presenting findings to the whole class during sharing time. ' +
        'Next steps include continuing to lead small-group investigations and documenting wonderings in a kindergarten science journal.',
      ersCompleted: 'yes',
      ersDateYear: '2025',
      ersDateMonth: '04',
      ersDateDay: '22',
      ersBenchmarkMet: 'yes',
      eceNames: 'Ms. Aisha Nguyen',
      _completedFields: [],
    },
  },
]
